var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContestDetails4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 31,
    viewBox: "0 0 82 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6016 30.4004L18.4016 23.9004L22.1016 30.4004H14.6016Z",
    fill: "#111733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1099 28.0359L2.60938 21.168L2.48736 22.5627L80.9879 29.4306L81.1099 28.0359Z",
    fill: "#111733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 10.9C20.8 16.3676 16.3676 20.8 10.9 20.8C5.43238 20.8 1 16.3676 1 10.9C1 5.43238 5.43238 1 10.9 1C16.3676 1 20.8 5.43238 20.8 10.9Z",
    stroke: "#057EE6",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9016 27.6996C79.7241 27.6996 81.2016 26.2221 81.2016 24.3996C81.2016 22.5771 79.7241 21.0996 77.9016 21.0996C76.079 21.0996 74.6016 22.5771 74.6016 24.3996C74.6016 26.2221 76.079 27.6996 77.9016 27.6996Z",
    fill: "#111733"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7984 30.6H1.19844C1.09844 30.6 0.898438 30.5 0.898438 30.3C0.898438 30.1 0.998437 30 1.19844 30H79.7984C79.8984 30 80.0984 30.1 80.0984 30.3C80.0984 30.5 79.9984 30.6 79.7984 30.6Z",
    fill: "#111733"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContestDetails4);
export default __webpack_public_path__ + "static/media/contest-details-4.f323d3c246d6725cb04d40321c903408.svg";
export { ForwardRef as ReactComponent };